export const MAINTENANCE_MODE = 'PAAR-2945-payex_maintenance_mode';
export const ENABLE_FEATURE = 'ENABLE_FEATURE';
export const FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_ERROR = 'FETCH_FEATURES_ERROR';
export const FF_HOLIDAY_BANNER_CN = 'PAAR-5353-holidayBannerCN';
export const FF_HOLIDAY_BANNER_IN = 'PAAR-7290-holidayBannerIN';
export const FF_HOLIDAY_BANNER_KR = 'PAAR-6781-holidayBannerKR';
export const FF_HOLIDAY_BANNER_VN = 'PAAR-7052-holidayBannerVN';
export const FF_HOLIDAY_BANNER_NP = 'PAAR-6809-holidayBannerNP';
export const FF_CAPTCHA = 'PAAR-4218-VerifyTokenInBackend';
export const FF_PAYING_FROM_INDIA_IN_USD = 'PAAR-5643-Mario';
export const FF_HIDE_SMS = 'LOOP-2203-hide-sms';
export const FF_CARD_ELEMENT_FLOW = 'PAAR-6964-CardElementFlow';
export const FF_OTP_SMS_VERIFICATION = 'PAAR-7181-otpSmsVerification';
export const FF_INDIA_TCS_NAVIGATION_FLOW = 'PAAR-7080-newIndiaTCSFlow';
export const FF_INDIA_FX_AB_TEST = 'PAAR-7300-hideNonFxIndia';
export const FF_CALCULATE_FOR_RBI = 'PAAR-7275-calculateForRbi';
export const FF_INDIA_PAYER_GUIDANCE = 'LOOP-2353-indiaPayerGuidance';
export const FF_DEADLINES_AB_TEST = 'LOOP-2373-deadlines';
export const FF_DEPRECATE_ACADEMIC_FIELDS = 'PAAR-7090-deprecateAcademicFields';
export const FF_EMAIL_LOOKUP_AUTOFILL = 'PAAR-7077-emailLookupAutofill';
export const FF_DOCCOLLECTOR_PROACTIVE_CONTROLS =
  'loop-doccollector-proactive_controls';
export const DOC_COLLECTOR_COMPLETED_EVENT = 'doc_collector_completed';
export const FF_CHINA_PAYER_GUIDANCE = 'LOOP-2351-chinaCnPayerGuidance';
export const FF_LRS_DOC_COLLECTOR_ELEMENT = 'PAAR-7762-lrsDocCollectorElement';
export const FF_FUIOU_DYNAMIC_FIELDS = 'PLTA-2-FuiouDynamicFields';
export const FF_CHANGE_PAYMENT_METHOD_CARD_ELEMENT =
  'PAAR-7523-ChangePaymentMethodCardElement';
export const FF_AADHAR_ESIGN = 'PLTA-6-Aadhar-Esign';
export const FF_CARD_REVAMP = 'PAAR-7919-CardRevamp-Phase1';
export const FF_UPOP_IMPROVEMENTS = 'INEX-4093-UpopImprovements';
export const FF_SAVED_CARDS = 'PAAR-7347-savedCardsOneOff';
export const FF_MPESA_ELEMENTS_INSTRUCTIONS =
  'INEX-4178-MpesaElementsInstructions';
export const FF_KES_BANK_TRANSFER_ELEMENTS_INSTRUCTIONS =
  'INEX-4178-KESBankTransferElementsInstructions';
export const FF_CHINA_STATUS_CLARITY = 'PLTA-283-chinaStatusClarity';

export const FEATURES = [
  MAINTENANCE_MODE,
  FF_CAPTCHA,
  FF_HOLIDAY_BANNER_CN,
  FF_HOLIDAY_BANNER_IN,
  FF_HOLIDAY_BANNER_KR,
  FF_HOLIDAY_BANNER_VN,
  FF_HOLIDAY_BANNER_NP,
  FF_PAYING_FROM_INDIA_IN_USD,
  FF_HIDE_SMS,
  FF_CALCULATE_FOR_RBI,
  FF_INDIA_PAYER_GUIDANCE,
  FF_INDIA_TCS_NAVIGATION_FLOW,
  FF_DEADLINES_AB_TEST,
  FF_DEPRECATE_ACADEMIC_FIELDS,
  FF_CHINA_PAYER_GUIDANCE,
  FF_LRS_DOC_COLLECTOR_ELEMENT,
  FF_FUIOU_DYNAMIC_FIELDS,
  FF_CHANGE_PAYMENT_METHOD_CARD_ELEMENT,
  FF_AADHAR_ESIGN,
  FF_UPOP_IMPROVEMENTS,
  FF_SAVED_CARDS,
  FF_MPESA_ELEMENTS_INSTRUCTIONS,
  FF_KES_BANK_TRANSFER_ELEMENTS_INSTRUCTIONS,
] as const;

export const FEATURE_TYPES = [FF_CAPTCHA, MAINTENANCE_MODE] as const;

export type FeatureFlag =
  | (typeof FEATURES)[number]
  | (typeof FEATURE_TYPES)[number];
